import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as UserActions from "../actions/user";
import { OverlayLoading } from "../components/common";
import AuthenticatedUserContext from "../contexts/AuthenticatedUserContext";
import * as Dtos from "../dtos/Tmd.dtos";
import { RequestState } from "../enumerations/RequestState";
import { ITmdState } from "../reducers/";

interface AuthenticatedUserProviderOwnProps {
    children: React.ReactNode;
}

interface AuthenticatedUserProviderStateProps {
    user?: Dtos.User;
    checkedAuthentication?: boolean;
    loadingUser?: boolean;
}

interface AuthenticatedUserProviderDispatchProps {
    loadUser?: UserActions.IUserLoadActionCreator;
}

type AuthenticatedUserProviderProps = AuthenticatedUserProviderOwnProps & 
    AuthenticatedUserProviderStateProps & 
    AuthenticatedUserProviderDispatchProps;

class AuthenticatedUserProviderComponent extends React.Component<AuthenticatedUserProviderProps> {
    componentDidMount() {
        const { user, loadUser, loadingUser } = this.props;
        
        if (!user && loadUser && !loadingUser) {
            loadUser();
        }
    }

    render() {
        const { user, checkedAuthentication, children } = this.props;

        if (!checkedAuthentication) {
            return <OverlayLoading />;
        }

        if (!user) {
            window.location.href =
                "/auth/openiddict?ReturnUrl=" +
                encodeURIComponent(window.location.pathname + window.location.search);
            return <OverlayLoading />;
        }

        return (
            <AuthenticatedUserContext.Provider value={{ user }}>
                {children}
            </AuthenticatedUserContext.Provider>
        );
    }
}

const mapStateToProps = (state: ITmdState): AuthenticatedUserProviderStateProps => {
    return {
        user: state.user.data,
        loadingUser:
            state.user.loadState &&
            state.user.loadState.status === RequestState.Pending,
        checkedAuthentication: state.user.checked,
    };
};

const mapDispatchToProps = (dispatch): AuthenticatedUserProviderDispatchProps => {
    return {
        loadUser: bindActionCreators(UserActions.LoadUser, dispatch),
    };
};

export const AuthenticatedUserProvider = connect(
    mapStateToProps,
    mapDispatchToProps
)(AuthenticatedUserProviderComponent);
